"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EyeOpenIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("./IconContainer"));
const EyeOpenIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-eye-open", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 24 17.567", role: "img", "aria-label": title },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fill: "currentColor", d: "M23.658,7.314A12.974,12.974,0,0,0,.4,7.122a3.617,3.617,0,0,0,0,3.323,12.974,12.974,0,0,0,23.254-.192A3.328,3.328,0,0,0,23.658,7.314ZM11.983,14.932a6.149,6.149,0,1,1,6.148-6.148A6.149,6.149,0,0,1,11.983,14.932Z", role: "presentation" }),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fill: "currentColor", d: "M11.983,5.27A3.514,3.514,0,1,0,15.5,8.784,3.514,3.514,0,0,0,11.983,5.27Z", role: "presentation" }))));
};
exports.EyeOpenIcon = EyeOpenIcon;
EyeOpenIcon.defaultProps = {
    title: "Eye open",
};
exports.default = EyeOpenIcon;
//# sourceMappingURL=EyeOpen.js.map